var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm._.empty, _vm.noMargin && _vm._.noMargin]},[_c('img',{class:_vm._.icon,style:(_vm.iconStyle),attrs:{"src":_vm.iconUrl}}),_c('div',{class:_vm._.message},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }